import { FETCH_TOGGLE, RESET_TOGGLES } from "../actions/types";

const INITIAL_STATE = {};

interface TogglePayload { 
    name: string,
    value: boolean
}

interface ToggleAction {
    type: string,
    payload: TogglePayload
} 

const ToggleReducer = (state = INITIAL_STATE, action: ToggleAction) =>
{
    switch(action.type)
    {
        case FETCH_TOGGLE:
            return {
                ...state,
                [action.payload.name]: action.payload.value
            };
        case RESET_TOGGLES:
            return {};
        default:
            return state;
    }
};

export default ToggleReducer;
